import { render, staticRenderFns } from "./page3.vue?vue&type=template&id=09f874dd&scoped=true&"
import script from "./page3.vue?vue&type=script&lang=js&"
export * from "./page3.vue?vue&type=script&lang=js&"
import style0 from "./page3.vue?vue&type=style&index=0&id=09f874dd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f874dd",
  null
  
)

export default component.exports